import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    layoutName: 'default',
    activeTitle: '',
    isLoading: true,
    sDefaults: {tab: 'thisweek', startDate: null, endDate: null},
    customDefault: {start: 1, end: 0},
    localitiesMaster: [],
    statusesMaster: []
  },
  mutations: {
    setLayout(state, layout){
      state.layoutName = layout
    },
    setActiveTitle(state, title){
      state.activeTitle = title
    },
    setLoading(state, isLoading){
      state.isLoading = isLoading
    },
    setLocalitiesMaster(state, localities){
      state.localitiesMaster = localities
    },
    setStatusesMaster(state, statuses){
      state.statusesMaster = statuses
    },
  },
  actions: {
    setLayout({commit}, layout){
      commit('setLayout', layout);
    },
    setActiveTitle({commit}, title){
      commit('setActiveTitle', title);
    },
    setLoading({commit}, isLoading){
      commit('setLoading', isLoading);
    },
    setLocalitiesMaster({commit}, localities){
      commit('setLocalitiesMaster', localities)
    },
    setStatusesMaster({commit}, statuses){
      commit('setStatusesMaster', statuses)
    },
  },
  getters: {
    layout(state){
      return state.layoutName;
    },
    activeTitle(state){
      return state.activeTitle;
    },
    isLoading(state){
      return state.isLoading;
    },
    sDefaults(state){
      return state.sDefaults;
    },
    localitiesMaster(state){
      return state.localitiesMaster;
    },
    statusesMaster(state){
      return state.statusesMaster;
    },
    customDefault(state){
      return state.customDefault;
    }
  }
})
